<template>
  <b-row
    v-if="showHeader"
    class="content-header no-print"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ translate(headingTitle) }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="(item, index) in normalizedBreadcrumb"
                :key="'bc-' + index + '-' + item.label"
                :active="item.active === true"
                :to="item.active ? undefined : item.linkTo"
              >
                {{ translate(item.label) }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right
    <b-col
      class="content-header-right text-md-right d-md-block d-none mb-1"
      md="3"
      cols="12"
    >
      <b-dropdown
        variant="link"
        no-caret
        toggle-class="p-0"
        right
      >

        <template #button-content>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="btn-icon"
          >
            <feather-icon icon="SettingsIcon" />
          </b-button>
        </template>

        <b-dropdown-item :to="{ name: 'apps-todo' }">
          <feather-icon
            icon="CheckSquareIcon"
            size="16"
          />
          <span class="align-middle ml-50">Todo</span>
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'apps-chat' }">
          <feather-icon
            icon="MessageSquareIcon"
            size="16"
          />
          <span class="align-middle ml-50">Chat</span>
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'apps-email' }">
          <feather-icon
            icon="MailIcon"
            size="16"
          />
          <span class="align-middle ml-50">Email</span>
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'apps-calendar' }">
          <feather-icon
            icon="CalendarIcon"
            size="16"
          />
          <span class="align-middle ml-50">Calendar</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
    -->
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  computed: {
    headingTitle() {
      const m = this.$route.meta || {}
      if (m.pageTitle) {
        return m.pageTitle
      }
      const items = this.normalizedBreadcrumb
      if (!items.length) {
        return ''
      }
      const last = items[items.length - 1]
      return last.label || ''
    },
    showHeader() {
      const m = this.$route.meta || {}
      if (m.hideBreadcrumb && !m.pageTitle && !this.normalizedBreadcrumb.length) {
        return false
      }
      return !!(this.headingTitle || this.normalizedBreadcrumb.length)
    },
    normalizedBreadcrumb() {
      const meta = (this.$route && this.$route.meta) || {}
      if (meta.hideBreadcrumb) {
        return []
      }
      const b = meta.breadcrumb
      const hasExplicit = Array.isArray(b) && b.length > 0
      const raw = hasExplicit
        ? b
        : meta.pageTitle
          ? [{ title: meta.pageTitle, active: true }]
          : []
      return raw.map((item) => {
        if (!item || typeof item !== 'object') {
          return { label: '', linkTo: undefined, active: false }
        }
        const label =
          item.title != null && item.title !== ''
            ? item.title
            : item.text != null
              ? item.text
              : ''
        let linkTo = null
        if (item.url != null && item.url !== '') {
          linkTo = item.url
        } else if (
          item.to !== undefined &&
          item.to !== null &&
          item.to !== ''
        ) {
          linkTo = item.to
        }
        if (linkTo === '#' || linkTo === '' || linkTo === '/#') {
          linkTo = undefined
        }
        return {
          label,
          linkTo,
          active: item.active
        }
      }).filter((item) => !this.isRedundantMuralCrumb(item))
    },
  },
  methods: {
    /** "Mural" com destino à raiz repete o ícone Home já exibido antes da trilha */
    isRedundantMuralCrumb(item) {
      const label = String(item.label || '').trim().toLowerCase()
      if (label !== 'mural') {
        return false
      }
      const to = item.linkTo
      if (typeof to === 'object' && to !== null) {
        return false
      }
      if (to === '/' || to === '/#') {
        return true
      }
      if (to === undefined || to === null || to === '') {
        return true
      }
      return false
    },
    translate(raw) {
      if (raw == null || raw === '') {
        return ''
      }
      const s = String(raw).trim()
      if (!s) {
        return ''
      }
      if (typeof this.$t !== 'function') {
        return s
      }
      try {
        const t = this.$t(s)
        if (typeof t === 'string' && t.length > 0) {
          return t
        }
        return s
      } catch (e) {
        return s
      }
    },
  },
}
</script>
